import { Box } from '@factorialco/deprecated-design-system'

interface ColumnByActiveActorProp {
  hasManagerData: boolean
  hasTargetData: boolean
  manager?: React.ReactElement | null
  managee?: React.ReactElement | null
}

const ColumnByActiveActor = ({
  hasManagerData,
  hasTargetData,
  manager,
  managee,
}: ColumnByActiveActorProp) => {
  if (hasManagerData && hasTargetData) {
    return (
      <>
        <Box width="full" gap="s12">
          {managee}
        </Box>
        <Box width="full" gap="s12">
          {manager}
        </Box>
      </>
    )
  }

  return (
    <Box width="full" gap="s12">
      {manager || managee}
    </Box>
  )
}

export default ColumnByActiveActor
